import React from "react";
import DrawerSidebar from "../DrawerSidebar";
import { Flex } from "@chakra-ui/react";
import { theme } from "src/styles/theme";

interface IMenu {
  selectedOption: string;
  setSelectedOption: any;
}

const Menu = ({ selectedOption, setSelectedOption }: IMenu) => {
  return (
    <Flex
      display={"flex"}
      pos={"fixed"}
      w={"100%"}
      h={"50px"}
      background={theme.disable100}
      zIndex={-999}
      transition={"0.2s"}
    >
      <Flex
        w={"90%"}
        h={"100%"}
        justifyContent={"center"}
        alignItems={"center"}
        pl={"18px"}
      >
        <DrawerSidebar
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        />
      </Flex>
    </Flex>
  );
};

export default Menu;
